import useReveal from "../lib/useReveal";

/**
 * Envuelve un bloque para que aparezca al entrar en pantalla.
 * `delay` escalona elementos de una misma fila sin sobrecargar la vista.
 */
export default function Reveal({
  children,
  as: Tag = "div",
  delay = 0,
  className = "",
  ...rest
}) {
  const [ref, visible] = useReveal();

  return (
    <Tag
      ref={ref}
      className={`fsg-reveal ${visible ? "is-visible" : ""} ${className}`.trim()}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
}
